import Vue from 'vue'
import Component from 'vue-class-component'
import configService from '@/config.service'

const REDOC_SCRIPT_URL = 'https://cdn.jsdelivr.net/npm/redoc@next/bundles/redoc.standalone.js'

@Component
export default class VApiExplorer extends Vue {
  get publicApiDocumentationUrl() {
    const { toolingApiHost } = configService.getConfig()
    return `${toolingApiHost}/documentation/public-api-documentation`
  }

  mounted() {
    const redocScript = document.createElement('script')
    redocScript.setAttribute('id', 'redoc-script')
    redocScript.setAttribute('src', REDOC_SCRIPT_URL)
    document.head.appendChild(redocScript)
  }

  destroyed() {
    const existingRedocScript = document.head.querySelector('#redoc-script')
    existingRedocScript && existingRedocScript.remove()
    const existingRedocStyle = document.head.querySelector('style[data-styled=""]')
    existingRedocStyle && existingRedocStyle.remove()
  }
}
